<script>
  import { fade } from "svelte/transition";
  import Img from "../components/Img.svelte";
  import Load from "../components/Load.svelte";
  export let data;
  import Alert from "../components/Alert.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import format from "number-format.js";
  import Rating from "../components/Rating.svelte";
  import ProductScrollX from "../components/ProductScrollX.svelte";

  import Placeholder from "../components/placeholder/Placeholder.svelte";
  import { redirect } from "../pager";
  //liblary
  import axios from "axios";
  import { session, notif } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  let _token = localStorage.getItem("t");

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];
  let alias = "";
  let id = "";
  if (data) {
    alias = data.alias;
    id = data.id;
  }

  let items = [];
  let itemsDisplay = false;
  $: if (settings) {
    loadProduct();
  }
  let notfound = false;
  function loadProduct() {
    axios
      .get(settings.url + "/warga/product/" + alias + "-" + id, {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        items = response.data;

        if (response.data) {
          setTimeout(() => {
            itemsDisplay = true;
          }, 2000);
        }
      })
      .catch(function (error) {
        if (error.response.status == 404) {
          notfound = true;
        } else if (error.response.status == 401) {
          localStorage.removeItem("t");
          itemsDisplay = true;
          alert = [
            ...alert,
            {
              message:
                "Sesi anda habis, silahkan perbaharui dengan cara login ulang",
              color: "orange",
            },
          ];
        } else {
          itemsDisplay = false;
          alert = [
            ...alert,
            { message: "Masalah Komunikasi Data", color: "red" },
          ];
        }
      })
      .then(function () {
        // always executed
      });
  }
  let jumlahorder = 1;
  let maxjumlahorder = 99999;
  let minjumlahorder = 1;
  function plusCart() {
    if (jumlahorder >= maxjumlahorder) {
      jumlahorder = maxjumlahorder;
    } else {
      if ((jumlahorder < 1) | !jumlahorder) {
        jumlahorder = 1;
      } else {
        jumlahorder = jumlahorder + 1;
      }
    }
  }
  function minCart() {
    if (jumlahorder <= minjumlahorder) {
      jumlahorder = minjumlahorder;
    } else {
      if ((jumlahorder < 1) | !jumlahorder) {
        jumlahorder = 1;
      } else {
        jumlahorder = jumlahorder - 1;
      }
    }
  }

  function addtoCart() {
    if (settings.token) {
      axios
        .post(settings.url + "/sipade/cart?authorization=" + settings.token, {
          productID: items.data.basic.ID,
          quantity: jumlahorder,
        })
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Produk Berhasil Ditambahkan",
              color: "green",
            },
          ];
          load_notif();
        })
        .catch(function (error) {
          if (error.response.status == 401) {
            localStorage.removeItem("t");
            redirect("/login");
          } else {
            if (error.response.data.message) {
              alert = [
                ...alert,
                {
                  title: "Dekatan",
                  message: error.response.data.message,
                  color: "orange",
                },
              ];
            } else {
              alert = [
                ...alert,
                {
                  title: "Dekatan",
                  message: "Anda belum terhubung dengan baik",
                  color: "orange",
                },
              ];
            }
          }
        });
    } else {
      redirect("/login");
    }
  }
  function load_notif() {
    if (_token) {
      axios
        .get(settings.url + "/sipade/notif", {
          params: {
            authorization: _token,
          },
        })
        .then(function (response) {
          notif.update((n) => response.data.notif);
        });
    }
  }
  function loadingBtn(e) {
    let el = this;
    el.setAttribute("disabled", "disabled");
    let reset = e.srcElement.innerHTML;
    this.innerHTML = "Memproses...";
    setTimeout(() => {
      el.innerHTML = reset;
      el.removeAttribute("disabled");
    }, 10000);
  }
  function changeImg(url, target) {
    var image = document.getElementById(target);
    if (image.src.match(url)) {
    } else {
      image.src = url;
    }
  }

  function btnfilterActivate() {
    Array.from(document.getElementsByClassName("imgOption")).forEach((el) => {
      el.classList.remove("opacity-100");
      el.classList.remove("shadow-lg");
      el.classList.add("opacity-50");
    });
    this.classList.add("opacity-100");
    this.classList.add("shadow-lg");
  }
</script>

<svelte:head>
  <title>Detail Produk - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div
    class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-20 lg:mb-10 lg:w-auto"
  >
    {#each alert as a}
      <Alert color={a.color} message={a.message} />
    {/each}
  </div>
{/if}
{#if items.data}
  <Navigationbar
    backbtn="true"
    message={navigation["message"]}
    title={items.data.basic.name}
  />
{:else}
  <Navigationbar
    backbtn="true"
    message={navigation["message"]}
    title="Detail Produk"
  />
{/if}

<main transition:fade class="container px-2 pt-24 mx-auto mb-20">
  {#if notfound == true}
    <div class="w-full px-2 mx-auto">
      <div class="w-full p-10 bg-white rounded-lg shadow-lg">
        <div class="my-6 text-center">
          <h2 class="text-3xl">Halaman yang dimaksud tidak tersedia !</h2>
          <p class="pb-5 text-gray-500">
            Mending sekarang kita cari-cari produk yang kamu suka
          </p>
          <a
            href="./belanja"
            class="px-10 py-2 text-xl text-white bg-blue-400 rounded-lg"
            >Cari Produk</a
          >
        </div>
      </div>
    </div>
  {:else if itemsDisplay}
    {#if items.data}
      <div class="px-3 py-5 mx-auto bg-white rounded-lg shadow-lg">
        <div class="flex flex-wrap mx-auto wrap-extended">
          <div
            class="w-full border-gray-400 border-none lg:w-2/5 lg:border-r md:border-r"
          >
            <picture
              class="relative block pb-3 border-b border-gray-300 lg:pr-3"
            >
              {#if items.data.pictures.length > 0}
                {#each items.data.pictures as p}
                  {#if p.statusPic === "1"}
                    <Img
                      randomid={false}
                      css="w-full rounded-lg"
                      datasrc="https://pics.dekatan.com/{p.fileName}"
                      alt={items.data.basic.name}
                      id="imageFeatured"
                    />
                  {/if}
                {/each}
              {:else}
                <img
                  class="w-full rounded-lg"
                  src="data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22600%22%20height%3D%22600%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20600%20600%22%20preserveAspectRatio%3D%22none%22%3E%0A%20%20%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%20%20%20%20%20%20%20%20%20%20%23holder%20text%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%20%23eeeeee%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-family%3A%20sans-serif%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-size%3A%2050px%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-weight%3A%20200%3B%0A%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%3C%2Fstyle%3E%0A%20%20%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%20%20%3Cg%20id%3D%22holder%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22%23fafafa%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cg%3E%0A%20%20%20%20%20%20%20%20%20%20%3Ctext%20text-anchor%3D%22middle%22%20x%3D%2250%25%22%20y%3D%2250%25%22%20dy%3D%22.3em%22%3E%5B%20dekatan%20%5D%3C%2Ftext%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fsvg%3E"
                  alt={items.data.basic.name}
                />
              {/if}
              <div class="flex justify-center w-full">
                {#if items.data.pictures.length > 0}
                  {#each items.data.pictures as ps}
                    {#if ps.statusPic === "1"}
                      <img
                        class="w-1/6 m-1 overflow-hidden rounded-lg opacity-100 cursor-pointer lg:h-20 h-15 hover:shadow-lg hover:opacity-100 imgOption"
                        src="https://pics.dekatan.com/{ps.fileName}"
                        alt={items.data.basic.name}
                        on:click={btnfilterActivate}
                        on:click={() =>
                          changeImg(
                            "https://pics.dekatan.com/" + ps.fileName,
                            "imageFeatured"
                          )}
                      />
                    {:else}
                      <img
                        class="w-1/6 m-1 overflow-hidden rounded-lg opacity-50 cursor-pointer lg:h-20 h-15 hover:shadow-lg hover:opacity-100 imgOption"
                        src="https://pics.dekatan.com/{ps.fileName}"
                        alt={items.data.basic.name}
                        on:click={btnfilterActivate}
                        on:click={() =>
                          changeImg(
                            "https://pics.dekatan.com/" + ps.fileName,
                            "imageFeatured"
                          )}
                      />
                    {/if}
                  {/each}
                {:else}
                  <img
                    class="w-1/6 m-1 overflow-hidden rounded-lg opacity-100 cursor-pointer lg:h-20 h-15 hover:shadow-lg hover:opacity-100 imgOption"
                    src="data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22600%22%20height%3D%22600%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20600%20600%22%20preserveAspectRatio%3D%22none%22%3E%0A%20%20%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%20%20%20%20%20%20%20%20%20%20%23holder%20text%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%20%23eeeeee%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-family%3A%20sans-serif%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-size%3A%2050px%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-weight%3A%20200%3B%0A%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%3C%2Fstyle%3E%0A%20%20%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%20%20%3Cg%20id%3D%22holder%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22%23fafafa%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cg%3E%0A%20%20%20%20%20%20%20%20%20%20%3Ctext%20text-anchor%3D%22middle%22%20x%3D%2250%25%22%20y%3D%2250%25%22%20dy%3D%22.3em%22%3E%5B%20dekatan%20%5D%3C%2Ftext%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fsvg%3E"
                    alt={items.data.basic.name}
                  />
                {/if}
              </div>
            </picture>
          </div>
          <div class="w-full h-auto p-3 pb-3 lg:w-3/5 lg:p-5 md:p-10">
            <div class="lg:sticky" style="top:100px">
              <nav class="flex items-center mb-4 text-sm lg:text-normal">
                <a class="transition hover:text-blue-600" href="/belanja">
                  Belanja
                </a>
                <span class="block mx-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="12"
                    viewBox="0 0 8 12"
                  >
                    <g fill="none" fill-rule="evenodd">
                      <path d="M-4-2h16v16H-4z" />
                      <path
                        fill="#676767"
                        fill-rule="nonzero"
                        d="M6.195 6L.862 11.333l.471.472L7.138 6 1.333.195.862.667z"
                      />
                    </g>
                  </svg>
                </span>
                <a
                  class="transition hover:text-blue-600"
                  href="belanja/c/{items.data.category.alias}/q/-"
                >
                  {items.data.category.title}
                </a>
              </nav>
              <h1 class="text-lg lg:text-xl lg:font-bold">
                {items.data.basic.name}
              </h1>

              <ul class="mt-3 font-medium">
                <li>
                  <span
                    class="inline-block my-2 mr-2 text-2xl font-bold text-orange-500 lg:text-xl"
                  >
                    {format("Rp #.###,", items.data.basic.price)},-
                  </span>
                </li>
              </ul>
              <div class="block font-mono uppercase">
                <mark
                  class="inline-block p-2 py-1 mt-4 mr-1 font-mono text-xs leading-none text-white uppercase bg-green-500 rounded-full"
                >
                  {format("#.###,", items.data.basic.weight)}
                  {items.data.basic.weightUnit}
                </mark>
                <mark
                  class="inline-block p-2 py-1 mt-4 mr-1 font-mono text-xs leading-none text-white uppercase bg-blue-500 rounded-full"
                >
                  {items.data.basic.cond}
                </mark>
              </div>
              <div data-controller="product">
                {#if items.data.owner}
                  <div
                    class="w-full p-2 mt-4 text-sm italic text-red-500 border border-l-4 border-red-500 rounded-lg"
                  >
                    Ini adalah produk anda,
                    <a
                      class="px-2 text-green-100 bg-green-600 rounded-full"
                      href="tokoku/update/{items.data.basic.alias}/{items.data
                        .basic.ID}">klik disini</a
                    >
                    untuk mengubah detail produk
                  </div>
                {:else}
                  <form on:submit|preventDefault={addtoCart} method="post">
                    <div
                      class="fixed bottom-0 left-0 z-10 flex items-center justify-between w-full p-2 mt-5 bg-white border-t shadow lg:relative lg:bg-tranparent md:bg-tranparent h-18 lg:justify-start lg:rounded-lg"
                    >
                      <div
                        class="flex justify-center px-1 py-1 mx-2 bg-white rounded-lg align-center w-26"
                      >
                        <i
                          class="w-8 h-8 p-1 mt-1 text-center transition-all duration-300 transform scale-100 rounded-full outline-none cursor-pointer select-none text-md hover:scale-110 m-r-2"
                          on:click|preventDefault={minCart}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            class="w-5 h-5 mx-auto"
                          >
                            <path
                              d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm5-9v2H5V9h10z"
                            /></svg
                          >
                        </i>
                        <input
                          type="number"
                          bind:value={jumlahorder}
                          min="1"
                          name="quantity"
                          class="relative w-16 py-1 mx-2 text-center border border-gray-400 rounded-lg outline-none appearance-none quantity"
                        />
                        <i
                          class="w-8 h-8 p-1 mt-1 text-center transition-all duration-300 transform scale-100 rounded-full outline-none cursor-pointer select-none text-md hover:scale-110 m-r-2"
                          on:click|preventDefault={plusCart}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            class="w-5 h-5 mx-auto"
                            ><path
                              d="M11 9h4v2h-4v4H9v-4H5V9h4V5h2v4zm-1 11a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
                            /></svg
                          >
                        </i>
                      </div>
                      <button
                        class="p-2 mx-2 text-sm text-white bg-orange-500 rounded-lg focus:bg-gray-500 focus:outline-none"
                        type="submit"
                        on:click={addtoCart}
                        on:click={loadingBtn}
                      >
                        + Keranjang
                      </button>
                    </div>
                  </form>
                {/if}
              </div>

              <div class="block mt-5 separator lg:hidden">Detail</div>
              <div class="flex-col w-full py-5 lg:flex">
                <section class="mb-8 paragraphs">
                  <h3 class="text-lg lg:text-xl">Deskripsi Produk</h3>
                  <h4 class="text-xs font-light">{items.data.basic.name}</h4>
                  <div
                    itemprop="description"
                    class="mt-3 text-sm font-light whitespace-pre-wrap"
                  >
                    {items.data.basic.description}
                  </div>
                </section>
                <a
                  href="belanja/{items.data.shop.domain}"
                  class="flex mt-4 text-xs leading-snug text-gray-700 cursor-pointer"
                  ><div class="w-16 h-auto px-1 py-2 overflow-hidden">
                    {#if items.data.shop.avatar != 0}
                      <Img
                        csscont="none"
                        showplaceholder="false"
                        id={items.data.shop.nameShop}
                        datasrc="https://pics.dekatan.com/shop/{items.data.shop
                          .avatar}"
                        alt={items.data.shop.nameShop}
                        css="rounded-full bg-gray-300 shadow-md"
                      />
                    {:else}
                      <img
                        id={items.data.shop.nameShop}
                        src="data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22600%22%20height%3D%22600%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20600%20600%22%20preserveAspectRatio%3D%22none%22%3E%0A%20%20%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%20%20%20%20%20%20%20%20%20%20%23holder%20text%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%20%23eeeeee%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-family%3A%20sans-serif%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-size%3A%2050px%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-weight%3A%20200%3B%0A%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%3C%2Fstyle%3E%0A%20%20%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%20%20%3Cg%20id%3D%22holder%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22%23fafafa%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cg%3E%0A%20%20%20%20%20%20%20%20%20%20%3Ctext%20text-anchor%3D%22middle%22%20x%3D%2250%25%22%20y%3D%2250%25%22%20dy%3D%22.3em%22%3E%5B%20dekatan%20%5D%3C%2Ftext%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fsvg%3E"
                        alt={items.data.shop.nameShop}
                        class="bg-gray-300 rounded-full shadow-md"
                      />
                    {/if}
                  </div>
                  <div>
                    <h5 class="m-3 mt-1 mb-0 text-xs text-gray-600">Penjual</h5>
                    <h4 class="mx-3 mb-0 text-lg">
                      {items.data.shop.nameShop}
                    </h4>
                    <span class="ml-2 text-xs font-light text-blue-600"
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        class="inline"
                        ><defs>
                          <path
                            id="a"
                            d="M12 12.209a3 3 0 1 1 0-6 3 3 0 0 1 0 6m-.001-10.21C8.072 2 5 4.968 5 8.785c0 4.837 4.446 10.154 6.251 12.1a1.01 1.01 0 0 0 1.491-.005C14.545 18.916 19 13.62 19 8.644 19 5.159 16.16 2 11.999 2"
                          />
                        </defs>
                        <g fill="none" fill-rule="evenodd">
                          <path d="M0 0h24v24H0z" />
                          <mask id="b" fill="#fff">
                            <use xlink:href="#a" />
                          </mask>
                          <use fill="#9FA6B0" xlink:href="#a" />
                          <g fill="#6C727C" fill-rule="nonzero" mask="url(#b)">
                            <path d="M1 1h22v22H1z" />
                          </g>
                        </g></svg
                      >
                      {items.data.shop.location}</span
                    >
                    {#if items.data.rating != 0}
                      <div class="my-2 ml-2">
                        <Rating size="6" rating={items.data.rating} />
                      </div>
                    {/if}
                  </div></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <ProductScrollX
        id={items.data.category.ID}
        title="Produk Serupa"
        subtitle="Lihat Lebih Banyak"
        href="./belanja/c/rumah-tangga-taman-benih-bibit-tanaman/q/-"
        img="https://images.unsplash.com/photo-1594568838442-ccc2c521e12d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=250&q=80"
      />
    {:else}
      <div class="px-3 py-5 mx-auto bg-white rounded-lg shadow-lg">
        <div class="flex flex-wrap mx-auto wrap-extended">
          <div
            class="w-full border-gray-400 border-none lg:w-2/5 lg:border-r md:border-r"
          >
            <picture
              class="relative block pb-3 border-b border-gray-300 lg:pr-3"
            >
              <Placeholder type="4" css="height: 100%;" />
            </picture>
          </div>
          <div class="w-full h-auto p-3 pb-3 lg:w-3/5 lg:p-5 md:p-10">
            <div class="p-2 lg:sticky" style="top:100px">
              <Placeholder type="2" css="height: 100%;" />
            </div>
          </div>
        </div>
      </div>
    {/if}
  {:else}
    <Load />
  {/if}
</main>
